/**
 * Параметры списка клиентов для админского GET /users.
 */
export interface ICustomersListQuery {
  limit?: number
  offset?: number
  first_name?: string
  last_name?: string
  phone?: string
  email?: string
  city?: string
  pizzeria_id?: number
  sortBy?: string
  sortOrder?: 'ASC' | 'DESC'
}

/**
 * Собирает query-параметры списка клиентов, пропуская пустые значения.
 * @param query — фильтры, пагинация и сортировка
 * @returns строка вида `?limit=20&offset=0&...` или пустая строка
 */
const buildCustomersQueryParams = (query?: ICustomersListQuery): string => {
  if (!query) {
    return ''
  }

  const searchParams = new URLSearchParams()

  Object.entries(query).forEach(([paramName, paramValue]) => {
    if (paramValue === undefined || paramValue === null) {
      return
    }
    if (typeof paramValue === 'string' && !paramValue.trim()) {
      return
    }
    searchParams.set(paramName, String(paramValue))
  })

  const queryString = searchParams.toString()
  return queryString ? `?${queryString}` : ''
}

export default buildCustomersQueryParams
